// ** React Imports
import ReactDOM from 'react-dom';

// ** Ant Design
import 'antd/dist/reset.css';
// import 'antd/dist/antd.less';

// ** Core styles
import './assets/scss/style.scss';
import './assets/fonts/1FTV-VIP-Peristiwa-1.ttf';
import './assets/fonts/NVN-Motherland-Signature-1.ttf';
import './assets/fonts/PlaywriteAUVICGuides-Regular.ttf';
import './assets/fonts/SVN-Snell-Bold.ttf';
import './assets/fonts/SVN-Snell.ttf';

// ** Service Worker
import * as serviceWorker from './serviceWorker';

// ** Lazy load app
import Bootstrap from './bootstrap';

ReactDOM.render(<Bootstrap />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
